/* RESPONSIBLE TEAM: team-proactive-support */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
import { buildValidations, validator } from 'ember-cp-validations';

export default buildValidations({
  steps: {
    description: 'Survey steps',
    validators: [validator('has-many'), validator('length', { min: 2 })],
  },
  paths: {
    description: 'Survey branching paths',
    validators: [validator('survey-has-valid-path-predicates')],
  },
});
